import chapter from '@src/configs/chapter';
import { TagTheme } from '@src/constants';

export const configMap = new Map<TagThemeType, BrandThemeConfig>([[TagTheme.Chapter, chapter]]);
